import { Component, Input, OnInit } from '@angular/core'
import { AuthService, RoutingService } from '@spartacus/core'
import { filter, map } from 'rxjs/operators'
import { Observable, of } from 'rxjs'
import { FilterOderEntriesWithProperty } from '../../../shared/utils/filter-orderEntries-withProperty'
import { CartDetailsComponent } from '@spartacus/cart/base/components'
import { OrderEntry } from '@spartacus/cart/base/root'
import { ActiveCartService, CartConfigService, SelectiveCartService } from '@spartacus/cart/base/core'
import { DataAnalyticsClickSource } from '../../../shared/mb-constants'

@Component({
  selector: 'mb-cart-details',
  templateUrl: './mb-cart-details.component.html',
  styleUrls: ['./mb-cart-details.component.scss']
})
export class MbCartDetailsComponent extends CartDetailsComponent implements OnInit {

  purchaseEntries$: Observable<OrderEntry[]> | null = null
  requestPriceEntries$: Observable<OrderEntry[]> | null = null
  itemsNo$: Observable<number> | null = null

  @Input() isDisplayedInCartPage = true

  @Input() orderEntries: OrderEntry[] = []

  @Input() isCustomerSpecificPrices = false

  @Input() showAddToCartButton = false

  @Input() dataAnalyticsClickSource: DataAnalyticsClickSource | undefined

  constructor (protected activeCartService: ActiveCartService,
               protected selectiveCartService: SelectiveCartService,
               protected authService: AuthService,
               protected routingService: RoutingService,
               protected cartConfigService: CartConfigService) {
    super(activeCartService, selectiveCartService, authService, routingService, cartConfigService)
  }

  ngOnInit (): void {
    if (this.isDisplayedInCartPage || !this.orderEntries?.length) {
      this.entries$ = this.activeCartService
        .getEntries()
        .pipe(filter((entries) => entries.length > 0))
    } else {
      this.entries$ = of(this.orderEntries)
    }

    this.purchaseEntries$ = FilterOderEntriesWithProperty.filterOrderEntries(this.entries$, true)
    this.requestPriceEntries$ = FilterOderEntriesWithProperty.filterOrderEntries(this.entries$, false)
    this.setItemNo()
  }

  setItemNo () {
    this.itemsNo$ = this.entries$.pipe(
      filter(entries => !!entries),
      map(entries => entries
        .map(entry => entry.quantity)),
      map(quantities => {
        let itemsNo = 0
        quantities.forEach( qty => {
          if (qty) {
            itemsNo += +qty
          }
        })
        return itemsNo
      })
    )
  }

}
